/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="6.68"
        height="11.93"
        viewBox="0 0 6.68 11.93"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <polygon
          points="6.66 11.22 1.41 6 6.68 0.7 5.97 0 0 6 5.96 11.93 6.66 11.22"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronLeftIcon';

export default Icon;
